import {Component, OnInit} from "@angular/core";
import {PaginationObject} from "../pagination-object";
import {SubmissionHistoryService} from "../../../shared/services/submission-history.service";
import {SubmissionSearchObject} from "../search-object";
import {DateUtil} from "../date-util";

@Component({
    selector: 'pagination',
    templateUrl: './pagination.component.html'
})
export class PaginationComponent implements OnInit {

    constructor(private submissionHistoryService: SubmissionHistoryService) {}

    pagination : PaginationObject = new PaginationObject()

    searchCriteria: SubmissionSearchObject = new SubmissionSearchObject()

    ngOnInit() {
        this.submissionHistoryService.currentPagination.subscribe(message => this.pagination = message);
        this.submissionHistoryService.currentSearchCriteria.subscribe(message => this.searchCriteria = message);
    }

    selectPage(page: any) {
        this.pagination.pageSize = page.pageSize;
        this.pagination.currentPage = page.pageIndex;
        this.submissionHistoryService.updatePagination(this.pagination.totalCount);
        if (this.searchCriteria != null && this.searchCriteria.submissionIdentifierType != "" && this.searchCriteria.submissionIdentifierType != null) {
            let startDate = this.searchCriteria.startDate == null ? "" : DateUtil.formatDate(this.searchCriteria.startDate);
            let endDate = this.searchCriteria.endDate == null ? "" : DateUtil.formatDate(this.searchCriteria.endDate);
            this.submissionHistoryService.getSearchTableContent(this.searchCriteria, startDate, endDate, this.pagination.currentPage);
        } else {
            this.submissionHistoryService.getSessionTableContent();
        }
        document.querySelector("#dashboardScrollPane").scrollTop = 0;
    }
}
